"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_STATUS = void 0;
// THIS IS AUTHORIZE PAYMENT STATUS, DON"T MAKE IT UPPERCASE
exports.PAYMENT_STATUS = {
    SUCCESS: 'success',
    FAILED: 'failed',
    REFUNDED: 'refunded'
};
//# sourceMappingURL=paymentStatus.js.map